import { Badge } from "react-bootstrap";
import { JsonCodeBlock } from "../JsonCodeBlock/JsonCodeBlock";
import type { WebhookPublication } from "../types";

export const statusVariant = (status: string): string => {
  switch (status) {
    case "success":
      return "success";
    case "error":
      return "danger";
    case "duplicate":
      return "warning";
    default:
      return "secondary";
  }
};

export interface PublicationDetailProps {
  publication: WebhookPublication;
}

export const PublicationDetail = ({
  publication,
}: PublicationDetailProps): JSX.Element => {
  const { status, httpStatus, sourceType, sourceId, createdAt, contents } =
    publication;
  return (
    <div className="p-3">
      <dl className="row mb-3">
        <dt className="col-sm-4">Status</dt>
        <dd className="col-sm-8">
          <Badge
            bg={statusVariant(status)}
            className="text-white text-capitalize"
          >
            {status}
          </Badge>
        </dd>
        <dt className="col-sm-4">HTTP Status</dt>
        <dd className="col-sm-8">{httpStatus ?? "—"}</dd>
        <dt className="col-sm-4">Source</dt>
        <dd className="col-sm-8">
          {sourceType ? `${sourceType} #${sourceId ?? "—"}` : "—"}
        </dd>
        <dt className="col-sm-4">Created</dt>
        <dd className="col-sm-8">
          {createdAt ? new Date(createdAt).toLocaleString() : "—"}
        </dd>
      </dl>
      <h6 className="text-muted">Published Content</h6>
      <JsonCodeBlock value={contents} />
    </div>
  );
};
